import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import { TraceLine } from './TraceLine.js';
import style from './Exception.css';
export var Exception =
/*#__PURE__*/
function (_Component) {
  _inherits(Exception, _Component);

  function Exception() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Exception);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Exception)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  _createClass(Exception, [{
    key: "render",
    value: function render() {
      var expanded = this.state.expanded || this.props.expanded;
      return React.createElement("span", {
        className: [style.exceptionRow, this.props.isPrevious ? style.previous : 'icon-caret-dark'].join(' '),
        onClick: this.clickHandler
      }, React.createElement("span", {
        className: style.exception
      }, this.props.isPrevious ? t('logreader', 'Caused by ') : '', this.props.Exception), ":\xA0", React.createElement("span", {
        className: style.message
      }, this.props.Message), React.createElement(StackTrace, {
        trace: this.props.Trace,
        expanded: expanded
      }), expanded && this.props.Previous ? [React.createElement(Exception, _extends({
        expanded: true
      }, this.props.Previous, {
        isPrevious: true
      }))] : []);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Exception;
}(Component);

function StackTrace(_ref) {
  var trace = _ref.trace,
      expanded = _ref.expanded;

  if (expanded) {
    return React.createElement("ol", {
      className: style.trace,
      start: "0"
    }, trace.map(function (trace, i) {
      return React.createElement(TraceLine, _extends({
        key: i
      }, trace));
    }));
  } else {
    return [];
  }
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Exception, "Exception", "/srv/http/owncloud/apps/logreader/js/Components/Exception.js");
  reactHotLoader.register(StackTrace, "StackTrace", "/srv/http/owncloud/apps/logreader/js/Components/Exception.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();